"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.execution = execution;
exports.updateIsPause = updateIsPause;

var _request = _interopRequireDefault(require("@/utils/request"));

function add(data) {
  return (0, _request.default)({
    url: 'api/jobs',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/jobs',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/jobs',
    method: 'put',
    data: data
  });
}

function updateIsPause(id) {
  return (0, _request.default)({
    url: 'api/jobs/' + id,
    method: 'put'
  });
}

function execution(id) {
  return (0, _request.default)({
    url: 'api/jobs/exec/' + id,
    method: 'put'
  });
}

var _default = {
  del: del,
  updateIsPause: updateIsPause,
  execution: execution,
  add: add,
  edit: edit
};
exports.default = _default;